/* Maichuo storefront, Direction 4: the hero model picker, the fit check, "Show all models" and the
   header cart. Model data comes from <script id="mc4-models-data"> (snippets/mc4-models-json.liquid):
   [{u: url, p: price, a: available, m: {n: name, s: short, y: year, g: generation, c: [A-numbers], o: order, t: fit to confirm}}] */
(function () {
  'use strict';
  function data() {
    var el = document.getElementById('mc4-models-data');
    if (!el) return [];
    try { return JSON.parse(el.textContent).sort(function (a, b) { return a.m.o - b.m.o; }); } catch (e) { return []; }
  }
  var MODELS = [];
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); };
  var norm = function (s) { return String(s).toLowerCase().replace(/iphone/g, '').replace(/[^a-z0-9]/g, ''); };
  var isCode = function (q) { return /^a\d/i.test(q.trim()); };
  function matches(x, q) {
    q = q.trim(); if (!q) return true;
    var n = norm(q); if (!n) return true;
    if (isCode(q)) return x.m.c.some(function (c) { return c.toLowerCase().indexOf(n) === 0; });
    var name = norm(x.m.n), short = norm(x.m.s);
    return name.indexOf(n) === 0 || short.indexOf(n) === 0 || name.indexOf(n) >= 0;
  }
  // exact name first ("15 Pro" before "15 Pro Max")
  function rank(list, q) {
    var n = norm(q);
    return list.slice().sort(function (a, b) {
      var ea = norm(a.m.s) === n || norm(a.m.n) === n ? 0 : 1, eb = norm(b.m.s) === n || norm(b.m.n) === n ? 0 : 1;
      return ea - eb || a.m.o - b.m.o;
    });
  }

  function picker(root) {
    var input = root.querySelector('input[type=search]'), out = root.querySelector('[data-mc4-results]');
    function draw() {
      var q = input.value.trim();
      if (!q) { out.innerHTML = ''; return; }
      var hits = rank(MODELS.filter(function (x) { return matches(x, q); }), q).slice(0, 4);
      out.innerHTML = hits.length ? hits.map(function (x) {
        var code = isCode(q) ? (x.m.c.filter(function (c) { return c.toLowerCase().indexOf(q.toLowerCase()) === 0; })[0] || '') : '';
        var grades = (x.g || []).length > 1 ? x.g.map(function (g) { return esc(g.n) + ' ' + esc(g.p); }).join(' · ') : '';
        return '<a href="' + esc(x.u) + '"><span><b>' + esc(x.m.n) + '</b><small>' + (code ? 'Model ' + esc(code) + ' · ' : '') + esc(x.m.y) +
          (grades ? '<br>' + grades : '') + '</small></span><span class="go">' + esc(x.p) + '</span></a>';
      }).join('') : '<div class="none">No screen for “' + esc(q) + '” yet. Tell us which model you need.</div>';
    }
    input.addEventListener('input', draw);
    root.querySelector('form').addEventListener('submit', function (e) {
      var a = out.querySelector('a');
      if (!a) { draw(); a = out.querySelector('a'); }
      if (a) { e.preventDefault(); window.location.href = a.getAttribute('href'); }
    });
    root.querySelectorAll('[data-mc4-chip]').forEach(function (c) {
      var n = norm(c.getAttribute('data-mc4-chip'));
      var hit = MODELS.filter(function (x) { return norm(x.m.s) === n; })[0];
      if (hit) c.setAttribute('href', hit.u);
    });
  }

  // "Show all models" lives in a details element; a link to the grid opens it too.
  function showAll() {
    document.querySelectorAll('a[href$="#mc4-models"]').forEach(function (a) {
      a.addEventListener('click', function () {
        var more = document.querySelector('[data-mc4-more]');
        if (more && a.hasAttribute('data-mc4-all')) more.open = true;
      });
    });
  }

  function fit(root) {
    var codes = root.getAttribute('data-codes').split(','), name = root.getAttribute('data-name');
    var input = root.querySelector('input'), out = root.querySelector('[data-mc4-out]');
    input.addEventListener('input', function () {
      var v = input.value.trim().toUpperCase().replace(/\s/g, '');
      if (v.length < 5) { out.textContent = ''; out.className = ''; return; }
      var hit = codes.indexOf(v) >= 0;
      var other = MODELS.filter(function (x) { return x.m.c.indexOf(v) >= 0; })[0];
      out.className = hit ? 'ok' : 'bad';
      if (hit) { out.textContent = '✓ ' + v + ' is an ' + name + '. This screen fits it.'; return; }
      out.innerHTML = '✗ ' + esc(v) + (other ? ' is an ' + esc(other.m.n) + '. <a href="' + esc(other.u) + '" style="text-decoration:underline">See the ' + esc(other.m.n) + ' screen</a>.' : ' is not an ' + esc(name) + '. Find your model on the homepage.');
    });
  }

  function cart() {
    var link = document.querySelector('[data-mc4-cart]');
    if (!link) return;
    link.addEventListener('click', function (e) {
      var d = document.getElementById('cart-drawer');
      if (d && typeof d.open === 'function') { e.preventDefault(); d.open(); }
    });
    var count = link.querySelector('[data-mc4-count]');
    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
        .then(function (c) { if (count) count.textContent = c.item_count; }).catch(function () {});
    }
    document.addEventListener('shopify:cart:lines-update', function (e) {
      if (e.promise && e.promise.then) e.promise.then(refresh, refresh); else setTimeout(refresh, 800);
    });
  }

  function init() {
    MODELS = data();
    document.querySelectorAll('[data-mc4-picker]').forEach(picker);
    showAll();
    document.querySelectorAll('[data-mc4-fit]').forEach(fit);
    cart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
